module.exports = __webpack_public_path__ + "img/Israel_Aerospace_Industries.0effa9f8.svg";